'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Recommendations

function Box(props) {
  var i18n = props.i18n;


  return _react2.default.createElement(
    'div',
    { className: 'small-box-wrap' },
    _react2.default.createElement(
      'div',
      { className: 'hotel-item' },
      _react2.default.createElement(
        'a',
        { href: props.pageUrl, target: '_blank', rel: 'noopener noreferrer' },
        _react2.default.createElement(
          'div',
          { className: 'hotel-item-sub' },
          _react2.default.createElement(
            'div',
            { className: 'hotel-item-upper' },
            props.review ? _react2.default.createElement(
              'div',
              { className: 'guest-rating-box' },
              _react2.default.createElement(
                'span',
                null,
                i18n.top.guestRating
              ),
              _react2.default.createElement(
                'span',
                { className: 'rating-score' },
                props.review
              ),
              _react2.default.createElement(
                'span',
                null,
                '\xA0/\xA05'
              )
            ) : _react2.default.createElement(
              'div',
              { className: 'guest-rating-box voyagin' },
              _react2.default.createElement('img', { alt: props.logoAlt || '', src: props.logoUrl })
            ),
            _react2.default.createElement(
              'div',
              { className: 'hotel-image-box' },
              _react2.default.createElement('div', { className: 'hotel-image-box-sub', style: { backgroundImage: 'url(' + props.imageUrl + ')', height: 200 } })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hotel-item-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'hotel-name' },
              props.name
            ),
            _react2.default.createElement(
              'div',
              { className: 'hotel-rate-stars' },
              _react2.default.createElement(
                'span',
                { className: 'for-reader' },
                i18n.top.forReader.replace(/{rate}/g, props.rate.toPrecision(2))
              ),
              _react2.default.createElement('span', { className: 'hotel-rate hotel-rate' + props.rate })
            )
          )
        )
      )
    )
  );
}

Box.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  name: _react.PropTypes.string.isRequired,
  pageUrl: _react.PropTypes.string.isRequired,
  imageUrl: _react.PropTypes.string.isRequired,
  rate: _react.PropTypes.number.isRequired,
  review: _react.PropTypes.number,
  logoUrl: _react.PropTypes.string,
  logoAlt: _react.PropTypes.string
};

var Recommendations = function (_Component) {
  (0, _inherits3.default)(Recommendations, _Component);

  function Recommendations(props) {
    (0, _classCallCheck3.default)(this, Recommendations);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Recommendations.__proto__ || (0, _getPrototypeOf2.default)(Recommendations)).call(this, props));

    _this.state = {
      visibleItemLength: 1
    };
    return _this;
  }

  (0, _createClass3.default)(Recommendations, [{
    key: 'showMore',
    value: function showMore(e) {
      e.preventDefault();
      if (this.props.items.length > this.state.visibleItemLength) {
        this.setState({ visibleItemLength: this.state.visibleItemLength + 1 });
      } else {
        this.setState({ visibleItemLength: 1 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          i18n = _props.i18n,
          items = _props.items;

      // TODO: confirm CSS style and layout

      return _react2.default.createElement(
        'div',
        { className: 'container featureRecommend featureHotelList' },
        _react2.default.createElement(
          'div',
          { className: 'heading' },
          _react2.default.createElement(
            'h2',
            { className: 'title' },
            i18n.top.ourTop
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          items.filter(function (item, index) {
            return index < _this2.state.visibleItemLength;
          }).map(function (item) {
            return _react2.default.createElement(
              'div',
              { key: item.name, className: 'top-destionations hotel-item-bottom' },
              _react2.default.createElement(
                'div',
                { className: 'upper-area' },
                _react2.default.createElement(
                  'div',
                  { className: 'big-box-wrap' },
                  _react2.default.createElement(
                    'div',
                    { className: 'big-box', style: { backgroundImage: 'url(' + item.imageUrl + ')' } },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: item.pageUrl, target: '_blank', rel: 'noopener noreferrer' },
                      _react2.default.createElement(
                        'p',
                        null,
                        item.name
                      )
                    )
                  )
                ),
                item.places.length ? item.places.filter(function (place, index) {
                  return index < 2;
                }).map(function (place) {
                  return _react2.default.createElement(Box, (0, _extends3.default)({}, place, { i18n: i18n, key: place.name }));
                }) : null
              ),
              item.places.length && item.places.length > 2 ? _react2.default.createElement(
                'div',
                { className: 'bottom-area' },
                item.places.filter(function (place, index) {
                  return index > 1;
                }).map(function (place) {
                  return _react2.default.createElement(Box, (0, _extends3.default)({}, place, { i18n: i18n, key: place.name }));
                })
              ) : null
            );
          }),
          _react2.default.createElement(
            'div',
            { className: 'more-link' },
            _react2.default.createElement(
              'a',
              { href: true, onClick: function onClick(e) {
                  return _this2.showMore(e);
                } },
              items.length > this.state.visibleItemLength ? i18n.ellipsis.showMore : i18n.ellipsis.showLess
            )
          )
        )
      );
    }
  }]);
  return Recommendations;
}(_react.Component);

Recommendations.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  items: _react.PropTypes.array.isRequired
};

exports.default = Recommendations;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recommendations.js
// module id = 1223
// module chunks = 0